module.exports = __webpack_public_path__ + "static/img/appback1.f91b5a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/appback1.png
// module id = TXLN
// module chunks = 1